module.exports = __webpack_public_path__ + "static/media/photo.97efd020.png";